// Token handling utility - Ensures proper token storage and retrieval
import { encryptObject, decryptObject } from './crypto.js'
import { STORAGE_KEYS } from './constants.js'
import { authUtil } from './auth.js'

const STORAGE_KEY = STORAGE_KEYS.USER_SESSION

/**
 * Store session data with token
 */
export function storeSession(sessionData) {
  try {
    if (!sessionData || !sessionData.token) {
      return false
    }

    const encrypted = encryptObject(sessionData)
    localStorage.setItem(STORAGE_KEY, encrypted)
    
    return true
  } catch (error) {
    return false
  }
}

/**
 * Retrieve session data (optimized - minimal validation)
 */
export function getSession() {
  try {
    const encryptedSession = localStorage.getItem(STORAGE_KEY)
    if (!encryptedSession) {
      return null
    }

    if (encryptedSession.startsWith('CRYPT_')) {
      const decrypted = decryptObject(encryptedSession)
      if (decrypted && decrypted.token) {
        return decrypted
      }
    }
    
    return null
  } catch (error) {
    return null
  }
}

/**
 * Clear session data
 */
export function clearSession() {
  try {
    localStorage.removeItem(STORAGE_KEY)
    return true
  } catch (error) {
    return false
  }
}

/**
 * Validate token exists and is valid
 */
export function validateToken() {
  try {
    const token = authUtil.getToken()
    return !!token
  } catch (error) {
    return false
  }
}

/**
 * Get current token with validation
 */
export function getCurrentToken() {
  try {
    return authUtil.getToken()
  } catch (error) {
    return null
  }
}